<template>
	<div :class="{'settings-group':true,'report-font-settings':true,'toggled':toggled,toggleable:true}" @click="toggleIt ( $event, true )">

		<h4 class="settings-group-title" v-if="title"><span v-html="title" /> <span class="toggle-link" @click="toggleIt ( $event, false )" v-html="toggled?'&lt;&lt; Hide &gt;&gt;':'&lt;&lt; Click here to view/edit &gt;&gt;'" /></h4>

		<div v-if="toggled">

			<div class="settings-group-grid two">
			
				<!-- Font Family -->
				<div class="setting-group">
					<label class="input-label">Font Family</label>
					<v-select
						v-model="font"
						:options="fontOptions"
						:reduce="(option) => option.value"
						label="label"
						:clearable="false"
						:searchable="false"
						:append-to-body="true"
						:placeholder="reportSettings.font? 'Default: ' + reportSettings.font : ''"
					/>
				</div>

				<ColourPicker 
					v-model="textColor"
					position="center-left" 
					title="Normal/Base Font Size/Color"
					class="setting-group" 
					:default="reportSettings.textColor"
					:formInput="{
						type: 'number',
						name: 'fontSize',
						min: 8,
						max: 24,
						required: false,
						placeholder: reportSettings.fontSize ? 'Default: ' + reportSettings.fontSize : '',
						value: componentSettings.fontSize
					}"
					@form-input-change="updateLocalSetting('fontSize',$event)"
				/>

			</div>

			<!-- Heading Sizes -->
			<div class="setting-group">
				<h4>Heading Sizes</h4>
				<div class="heading-sizes">
					<ColourPicker 
						v-for="i in 6"
						:key="i"
						v-model="$data['h'+i+'Color']"
						:position="hPos (i)" 
						:title="'Heading '+i+' Font Size/Color'"
						class="setting-group" 
						:default="reportSettings['h'+i+'Color']||'#000000'"
						:formInput="{
							type: 'number',
							name: 'h'+i+'Size',
							placeholder: reportSettings['h'+i+'Size'] ? 'Default: ' + reportSettings['h'+i+'Size'] : '',
							min: 12,
							max: 48,
							required: false,
							value: componentSettings['h'+i+'Size']
						}"
						@form-input-change="updateLocalSetting('h'+i+'Size',$event)"
					/>
				</div>
			</div>

		</div>
		
	</div>
</template>

<script>
	import FormInput from "../Form/Input.vue";
	import ColourPicker from "../Display/ColourPicker.vue";

	export default {
		name: "ReportFontSettings",
		components: {
			FormInput,
			ColourPicker
		},
		props: {
			componentSettings: {
				type: Object,
				default: () => ({}),
			},
			reportSettings: {
				type: Object,
				default: () => ({}),
			},
			varName: {
				type: String,
				default: 'reportSettings',
			},
		},
		data() {
			return {
				toggled: false,
				fontOptions: [
					{ label: "Courier", value: "Courier" },
					{ label: "Futura LT", value: "FuturaLT" },
					{ label: "Futura LT Condensed", value: "FuturaLTCondensed" },
					{ label: "Futura LT Light", value: "FuturaLTLight" },
					{ label: "Futura LT Book", value: "FuturaLTBook" },
					{ label: "Helvetica", value: "Helvetica" },
					{ label: "Roboto", value: "Roboto" },
					{ label: "Times", value: "Times" },
				],
				fontSizeOptions: [
					{ label: "H1", value: "h1" },
					{ label: "H2", value: "h2" },
					{ label: "H3", value: "h3" },
					{ label: "H4", value: "h4" },
					{ label: "H5", value: "h5" },
					{ label: "Normal", value: "p" },
				],
				font: this.componentSettings.font || null,
				textColor: this.componentSettings.textColor || '',
				h1Color: this.componentSettings['h1Color'] || '',
				h2Color: this.componentSettings['h2Color'] || '',
				h3Color: this.componentSettings['h3Color'] || '',
				h4Color: this.componentSettings['h4Color'] || '',
				h5Color: this.componentSettings['h5Color'] || '',
				h6Color: this.componentSettings['h6Color'] || '',
			};
		},
		watch: {
			font: {
				handler(newVal) { 
					this.updateLocalSetting('font', newVal);
				},
			},
			textColor: {
				handler(newVal) { 
					this.updateLocalSetting('textColor', newVal);
				},
			},
			h1Color: {
				handler(newVal) {
					this.updateLocalSetting('h1Color', newVal);
				},
			},
			h2Color: {
				handler(newVal) {
					this.updateLocalSetting('h2Color', newVal);
				},
			},
			h3Color: {
				handler(newVal) {
					this.updateLocalSetting('h3Color', newVal);
				},
			},
			h4Color: {
				handler(newVal) {
					this.updateLocalSetting('h4Color', newVal);
				},
			},
			h5Color: {
				handler(newVal) {
					this.updateLocalSetting('h5Color', newVal);
				},
			},
			h6Color: {
				handler(newVal) {
					this.updateLocalSetting('h6Color', newVal);
				},
			}
		},
		methods: {

			hPos (i) {

				if ( i === 1 || i === 4 ) return 'center-right';
				if ( i === 2 || i === 5 ) return 'top-center';
				if ( i === 3 || i === 6 ) return 'center-left';

			},

			updateLocalSetting(key, value) { 
				this.$emit('updated', { varName: this.varName, key, value });
			},

			toggleIt ( e, isParent ) {

				if ( isParent && this.toggled ) return;

				e.stopPropagation();

				this.toggled = !this.toggled;

			}

		},
		computed: {
			title () {
				return 'Font Settings';
			}
		},
	};
</script>

<style lang="less" scoped>
	@import "../../assets/css/less/_settings.less";
	
	.settings-group-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
		gap: 1rem;
		margin-bottom: 1rem;
		&.two {
			grid-template-columns: repeat(2, 1fr);
		}
	}

	.heading-sizes {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
		gap: 1rem;
		margin-top: 0.5rem;
	}

	.report-font-settings {
		margin-top: 20px;
		
		h4 {
			margin-bottom: 15px;
		}
	}
	
	// Add font preview styles for dropdown options
	:deep(.vs__dropdown-option) {
		&[data-font="Roboto"] {
			font-family: "Roboto", sans-serif;
		}
		&[data-font="Courier"] {
			font-family: "Courier", monospace;
		}
		&[data-font="Helvetica"] {
			font-family: "Helvetica", sans-serif;
		}
		&[data-font="Times"] {
			font-family: "Times", serif;
		}
	}

	.setting-group {
		margin: 1rem 0 0;

		.input-label {
			display: block;
			margin-bottom: 0.25rem !important;
			font-size:14px !important;
			font-weight: normal !important;
		}

		.settings-group-description {
			padding: 0;
			margin: 0 0 1rem;
		}

		.settings-group-title {
			margin-bottom: 0.5rem;
		}

		.large-button {
			&.mini {
				margin: 10px 20px 10px 0;
			}
		}

		.logo-preview {
			max-width: 250px;
			height: auto;
			max-width: 100px;
		}

		hr {
			margin: 2em 0;
		}
	}

	.toggled {
		background-color: fade(@formDefaultColour, 5%);
		padding: 1rem;
		border-radius: 0.5rem;
	}
	
	.toggle-link {
		cursor: pointer;
		opacity: 0.9;
		font-weight: normal;
		display: inline-block;
		margin-left: 0.4rem;
		&:hover {
			opacity: 1;
		}
	}

// Enhanced styles for better discoverability of toggle sections
// Add these styles to your existing LESS files or create a new one to import

// Common styles for all three components
.settings-group, .table-settings-section, .setting-group {

	&.toggleable {

		margin: 0.5rem 0 0 !important;

	}
  
  // Enhanced styling when collapsed (not toggled)
  &:not(.toggled) {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border: 2px solid #dee2e6;
    border-radius: 12px;
    padding: 1rem 1.5rem;
    margin: 0 0 0;
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    
    // Subtle animated gradient background
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
      transition: left 0.6s ease;
    }

	&.toggleable {
    
		&:hover {
		transform: translateY(-2px);
		box-shadow: 0 8px 25px rgba(0,0,0,0.1);
		border-color: #6c757d;
		
		&::before {
			left: 100%;
		}
		
		.toggle-link {
			color: #495057;
			font-weight: 600;
		}
		
		h4 {
			color: #495057;
		}
		}

	}
    
    // Add subtle pulse animation to draw attention
    animation: subtle-pulse 3s ease-in-out infinite;
  }
  
  // Enhanced h4 styling
  h4 {
    margin-bottom: 0.5rem;
    color: #6c757d;
    font-weight: 600;
    font-size: 1.1rem;
    transition: color 0.3s ease;
    
    // Add an icon before the title
    &::before {
      content: '⚙️';
      margin-right: 0.5rem;
      font-size: 1rem;
    }
  }
  
  // Specific icons for each component type
  &.settings-group h4::before {
    content: '📐'; // Page margins icon
  }
  
  &.table-settings-section h4::before {
    content: '📊'; // Table icon
  }
  
  &.graph-text-settings h4::before {
    content: '📈'; // Graph icon
  }

  &.report-font-settings h4::before {
    content: '🔤'; // Font icon
  }
}

// Enhanced toggle link styling
.toggle-link {
  cursor: pointer;
  opacity: 0.8;
  font-weight: 500;
  display: inline-block;
  margin-left: 0.5rem;
  color: #6c757d;
  transition: all 0.3s ease;
  padding: 0.25rem 0.75rem;
  background: rgba(108, 117, 125, 0.1);
  border-radius: 20px;
  font-size: 0.85rem;
  border: 1px solid rgba(108, 117, 125, 0.2);
  
  &:hover {
    opacity: 1;
    background: rgba(108, 117, 125, 0.15);
    border-color: rgba(108, 117, 125, 0.3);
    transform: scale(1.05);
  }
  
  // Add arrow indicators
  &::after {
    content: ' →';
    transition: transform 0.3s ease;
  }
  
  // When section is toggled (expanded)
  .toggled & {
    background: rgba(220, 53, 69, 0.1);
    border-color: rgba(220, 53, 69, 0.3);
    color: #dc3545;
    
    &::after {
      content: ' ↑';
      transform: rotate(180deg);
    }
    
    &:hover {
      background: rgba(220, 53, 69, 0.15);
    }
  }
}

// Enhanced toggled (expanded) state
.toggled {
  background-color: fade(@formDefaultColour, 8%);
  padding: 1.5rem;
  border-radius: 12px;
  margin-top: 1rem;
  border: 2px solid fade(@formDefaultColour, 20%);
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  
  h4 {
    margin-bottom: 1.5rem;
    color: @formDefaultColour;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid fade(@formDefaultColour, 20%);
  }
}

// Pulse animation for attention
@keyframes subtle-pulse {
  0%, 100% {
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  }
  50% {
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  }
}

// Responsive adjustments
@media (max-width: 768px) {
  .settings-group, .table-settings-section, .setting-group {
    &:not(.toggled) {
      padding: 1rem;
      margin: 1rem 0;
    }
    
    h4 {
      font-size: 1rem;
    }
    
    .toggle-link {
      display: block;
      margin: 0.5rem 0 0 0;
      text-align: center;
    }
  }
}

// Additional fix for modal scroll containers
.modal-inner-scroll {
  .settings-group, .table-settings-section, .setting-group {
    &:not(.toggled) {
      // Ensure proper sizing within flex containers
      flex: none;
      width: 100%;
      box-sizing: border-box;
    }
  }
}

// Section-specific enhancements
.settings-group:not(.toggled) {
  // Page margins - blue theme
  border-left: 4px solid #007bff;
  
  &:hover {
    border-left-color: #0056b3;
  }
}

.table-settings-section:not(.toggled) {
  // Table settings - green theme  
  border-left: 4px solid #28a745;
  
  &:hover {
    border-left-color: #1e7e34;
  }
}

.graph-text-settings:not(.toggled) {
  // Graph settings - purple theme
  border-left: 4px solid #6f42c1;
  
  &:hover {
    border-left-color: #5a32a3;
  }
}

.report-font-settings:not(.toggled) {
  // Font settings - orange theme
  border-left: 4px solid #fd7e14;
  
  &:hover {
    border-left-color: #e55a00;
  }
}

// Add subtle descriptions when collapsed
.settings-group:not(.toggled) h4::after {
  content: ' - Configure page layout and component positioning';
  font-size: 0.8rem;
  font-weight: normal;
  color: #6c757d;
  display: block;
  margin-top: 0.25rem;
}

.table-settings-section:not(.toggled) h4::after {
  content: ' - Customize table styling, borders, and colors';
  font-size: 0.8rem;
  font-weight: normal;
  color: #6c757d;
  display: block;
  margin-top: 0.25rem;
}

.graph-text-settings:not(.toggled) h4::after {
  content: ' - Set font sizes and colors for chart elements';
  font-size: 0.8rem;
  font-weight: normal;
  color: #6c757d;
  display: block;
  margin-top: 0.25rem;
}

.report-font-settings:not(.toggled) h4::after {
  content: ' - Configure font families, sizes, and text colors';
  font-size: 0.8rem;
  font-weight: normal;
  color: #6c757d;
  display: block;
  margin-top: 0.25rem;
}
</style>
